import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_92: FaireProductEntity = {
  token: "legacy_prod_abbott-92",
  type: "product",
  name: "Small Velvet Pouch with 3D Crown, Burgundy 4×6 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/f0148981e64520d578fe70ae464475caf213e9c16cf1b163d1e05418175eb906.jpeg",
  priceDollars: 10,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_womens-accessories"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
